import { render, staticRenderFns } from "./ArticleJournal.vue?vue&type=template&id=f335bc9c&"
import script from "./ArticleJournal.vue?vue&type=script&lang=js&"
export * from "./ArticleJournal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleJournal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports